import { render, staticRenderFns } from "./LogViewer.vue?vue&type=template&id=672b5bbc&scoped=true"
import script from "./LogViewer.vue?vue&type=script&lang=js"
export * from "./LogViewer.vue?vue&type=script&lang=js"
import style0 from "./LogViewer.vue?vue&type=style&index=0&id=672b5bbc&prod&lang=scss&scoped=true"
import style1 from "./LogViewer.vue?vue&type=style&index=1&id=672b5bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b5bbc",
  null
  
)

/* custom blocks */
import block0 from "./LogViewer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports